import type { ModuleManifest, RequestFormDef } from "@dd/module-api";
import { lazy } from "react";

export const BANCO_FORMS: readonly RequestFormDef[] = [
  {
    id: "mod.banco:extracto",
    title: "Extracto de cuenta",
    description: "Movimientos de los últimos 90 días de un titular.",
    fields: [{ id: "titular", label: "Titular", source: "cast" }],
  },
  {
    id: "mod.banco:informe",
    title: "Informe crediticio",
    description: "Deudas registradas, refinanciaciones y reclamos.",
    fields: [{ id: "titular", label: "Titular", source: "cast" }],
  },
] as const;

export const BANCO_MANIFEST: ModuleManifest = {
  id: "mod.banco",
  version: "1.0.0",
  title: "BancoMar",
  glyph: "◫",
  component: lazy(() => import("./BancoApp")),
  defaultSize: { w: 520, h: 540 },
  artifactTypes: ["extracto", "recibo"],
  requestForms: BANCO_FORMS,
  eraSkins: ["2011"],
};
